import regeneratorRuntime from "regenerator-runtime";
export default class Subscription {
  constructor(stripeKey) {
    this.stripeStyle = {}
    this.stripeKey = stripeKey
    this.checkoutOptions = {
      stripeSecret: null,
      subscriptionId: null,
      customerName: null
    }
    this.individualProducerProductID = ''
  }

  // Signup
  attachCheckout(form, stripeField, submit, emergingProducerProductID, individualProducerProductID) {
      this.individualProducerProductID = individualProducerProductID
    // Attach Stripe Elements
    const stripe = Stripe(this.stripeKey);
    const elements = stripe.elements();
    const card = elements.create('card', { hidePostalCode: true });
    card.mount(stripeField);

    // Deal with emerging producer or Individual Producer special cases
    document.querySelectorAll('input[name="subscription"]').forEach(input => {
      input.addEventListener('change', event => {
        form.querySelector('#emerging-producer-details').style.display = 'none'
        form.querySelector('#individual-producer-details').style.display = 'none'
        if (input.value === emergingProducerProductID) {
            form.querySelector('#emerging-producer-details').style.display = 'block'
        } else if (input.value === individualProducerProductID) {
            form.querySelector('#individual-producer-details').style.display = 'block'
        }
      })

      document.querySelectorAll('input[name="emerging_festival"]').forEach(input => {
        input.addEventListener('change', event => {
          if (input.value == 'other') {
            form.querySelector('#emerging_festival_info_name').style.display = 'block'
          } else {
            form.querySelector('#emerging_festival_info_name').style.display = 'none'
          }
        })
      })
    })

      // Auto-select correct membership based on URL query params
      const urlParams = new URLSearchParams(window.location.search);
      let membership = urlParams.get('membership');
      if (membership) {
          membership = parseInt(membership)
          const options = document.querySelectorAll('input[name="subscription"]')
          options[membership]?.click()
      }

    // Attach checkout
    submit.addEventListener('click', (event) => {
      event.preventDefault();
      this.checkout(form, card, stripe)
    })
  }

  async checkout(form, card, stripe) {
    // Add button loading state
    const btn = document.querySelector('#signup-button');
    btn.classList.add('loading')
    btn.innerHTML = 'Loading'

    // Do nothing if the TOS aren't checked
    if(!document.getElementById('terms').checked) {
      this.renderErrors({
        terms: {
          'terms': 'You need to accept the Terms & Conditions'
        }
      })
      return
    }

    const data = this.collectSignupData(form)

    // Special Case: Individual members need to confirm their status (much like TOS)
    if (data.subscription === this.individualProducerProductID) {
      if(!document.getElementById('is_individual').checked) {
          this.renderErrors({
              terms: {
                  'is_individual': 'You need to confirm that you are the exclusive owner of the company'
              }
          })
        return
      }
    }

    const response = await fetch('/memberships', {
     method: 'POST',
     body: JSON.stringify(data),
    })

    if (!response.ok) {
      return await this.handleCheckoutError(response)
    } else {
      const data = await response.json()
      this.checkoutOptions.stripeSecret = data.clientSecret
      this.checkoutOptions.subscriptionId = data.subscriptionId
      this.checkoutOptions.customerName = data.name
      this.payWithStripe(form, card, stripe)
    }
  }

  async handleCheckoutError(response) {
    if (response.status === 400) {
      const data = await response.json()
      switch (data.reason) {
        case 'validation':
          this.renderErrors(data.errors)
          break;
        case 'password':
           this.renderErrors({
             password: {
               'password': 'The password needs to have at least 6 characters'
             }
           })
           break;
        case 'emerging_festival':
        case 'emerging_production':
          this.renderErrors({
            emerging_festival: {
              'emerging_festival': 'Emerging producer information is required'
            }
          })
          break;
        case 'user_exists':
          this.renderErrors({
            email: {
              'unique': 'A user with this e-mail address already exists'
            }
          })
          break;
        case 'missing_subscription_tier':
        default:
          this.renderErrors({
            general: {
              'general': 'An unexpected error occurred. Please try again later.'
            }
          })
          break;
      }
    } else {
      this.renderErrors({
        general: {
          'general': 'An unexpected error occurred. Please try again later.'
        }
      })
    }
  }

  renderErrors(errors) {
    // Clear errors
    document.getElementById('errors').innerHTML = ''
    document.getElementById('errors').classList.add('active');

    // Clear button loading state
    const btn = document.querySelector('#signup-button');
    if(btn) {
      btn.classList.remove('loading')
      btn.innerHTML = 'Pay Now'
    }

    // Render errors
    const errorList = document.createElement('ul')
    Object.keys(errors).forEach(key => {
      const error = Object.keys(errors[key])[0]
      const errorElement = document.createElement('li')
      errorElement.innerText = errors[key][error]
      errorList.appendChild(errorElement)
    })
    document.getElementById('errors').appendChild(errorList)
  }

  async payWithStripe(form, card, stripe) {
    const response = await stripe.confirmCardPayment(this.checkoutOptions.stripeSecret, {
      payment_method: {
        card: card,
        billing_details: {
          name: this.checkoutOptions.customerName,
        },
      }
    })

    if (response.error) {
      this.renderErrors({
        'card': {
          'card': response.error.message
        }
      })
    } else {
      // Success!
      // Redirect the user to their new dashboard
      window.location.pathname = '/dashboard';
    }
  }

  collectSignupData(form) {
    let data = {}
    form.querySelectorAll('input,textarea').forEach(field => {
      if (field.type === 'radio') {
        if (field.checked) {
          data[field.name] = field.value
        }
        return
      }
      if (field.name && field.name !== "") {
        data[field.name] = field.value
      }
    })

    // Listing
    const listingCheckbox = document.getElementById('listing')
    if(listingCheckbox) {
      data['hideProfile'] = !listingCheckbox.checked
    } else {
      delete data['hideProfile']
    }

    // Emerging Producers handling
    if (data['emerging_festival'] == 'other') {
      data['emerging_festival'] = data['emerging_festival_name'];
    }
    return data
  }

  // Re-Signup
  attachResignup(stripeField, membershipPlanField, submit, errors, emergingProducerProductID, emergingField, individualProducerProductID) {
      this.individualProducerProductID = individualProducerProductID
    // Attach Stripe Elements
    const stripe = Stripe(this.stripeKey);
    const elements = stripe.elements();
    const card = elements.create('card', {
      hidePostalCode: true
    });
    card.mount(stripeField);

    // Deal with emerging producer special cases
    document.querySelectorAll('input[name="subscription"]').forEach(input => {
      input.addEventListener('change', event => {
          emergingField.querySelector('#emerging-producer-details').style.display = 'none'
          document.querySelector('#individual-producer-details').style.display = 'none'
        if (input.value === emergingProducerProductID) {
            emergingField.querySelector('#emerging-producer-details').style.display = 'block'
        } else if (input.value === individualProducerProductID) {
            document.querySelector('#individual-producer-details').style.display = 'block'
        }
      })

      document.querySelectorAll('input[name="emerging_festival"]').forEach(input => {
        input.addEventListener('change', event => {
          if (input.value == 'other') {
            emergingField.querySelector('#emerging_festival_info_name').style.display = 'block'
          } else {
            emergingField.querySelector('#emerging_festival_info_name').style.display = 'none'
          }
        })
      })
    })

    submit.addEventListener('click', (event) => {
      event.preventDefault()
      this.resignup(card, stripe, emergingField)
    })

  }

  async resignup(card, stripe, form) {
    let membershipPlan = null
    document.getElementById('re-signup-options')
        .querySelectorAll('input[type="radio"]')
        .forEach(option => {
          if (option.checked) {
            membershipPlan = option.value
          }
        })

    let data = {}
    form.querySelectorAll('input,textarea').forEach(field => {
      if (field.type === 'radio') {
        if (field.checked) {
          data[field.name] = field.value
        }
        return
      }
      if (field.name && field.name !== "") {
        data[field.name] = field.value
      }
    })

    if (data['emerging_festival'] == 'other') {
      data['emerging_festival'] = data['emerging_festival_name'];
    }

      // Special Case: Individual members need to confirm their status (much like TOS)
      if (membershipPlan === this.individualProducerProductID) {
          if(!document.getElementById('is_individual').checked) {
              this.renderErrors({
                  terms: {
                      'is_individual': 'You need to confirm that you are the exclusive owner of the company'
                  }
              })
              return
          }
      }

    const response = await fetch('/memberships/resignup', {
      method: 'POST',
      body: JSON.stringify({
        membershipPlan,
        emerging_festival: data['emerging_festival'],
        emerging_production: data['emerging_production']
      })
    })

    if (!response.ok) {
      this.handleUpdateError(response)
    } else {
      const data = await response.json()
      this.checkoutOptions.stripeSecret = data.clientSecret
      this.checkoutOptions.subscriptionId = data.subscriptionId
      this.checkoutOptions.customerName = data.name
      await this.resignupWithStripe(card, stripe)
    }
  }

  async resignupWithStripe(card, stripe) {
    const response = await stripe.confirmCardPayment(this.checkoutOptions.stripeSecret, {
      payment_method: {
        card: card,
        billing_details: {
          name: this.checkoutOptions.customerName,
        },
      }
    })

    if (response.error) {
      this.renderErrors({
        'card': {
          'card': response.error.message
        }
      })
    } else {
      // Success!
      // Reload the dashboard to show changes
      window.location.reload();
    }
  }

  // Update
  attachUpdate(updateForm, updateButton) {
    updateButton.addEventListener('click', (event) => {
      event.preventDefault();
      this.update(updateForm)
    });
  }

  async update(form) {
    const data = this.collectSignupData(form)
    const response = await fetch('/memberships/update', {
      method: 'POST',
      body: JSON.stringify(data),
    })

    if (!response.ok) {
      return await this.handleUpdateError(response)
    } else {
      const body = await response.json()
      document.getElementById('message').innerHTML = "<p>Profile updated.</p>";
      document.getElementById('message').classList.add('active');
      document.getElementById('preview-link').href = body.directorySlug;
    }
  }

  async handleUpdateError(response) {
    if (response.status === 400) {
      const data = await response.json()
      switch (data.reason) {
        case 'validation':
          this.renderErrors(data.errors)
          break;
        case 'password':
          this.renderErrors({
            password: {
              'password': 'The password needs to have at least 6 characters'
            }
          })
          break;
        case 'emerging_festival':
        case 'emerging_production':
          this.renderErrors({
            emerging_festival: {
              'emerging_festival': 'Emerging producer information is required'
            }
          })
          break;
        default:
          this.renderErrors({
            general: {
              'general': 'An unexpected error occurred. Please try again later.'
            }
          })
          break;
      }
    } else {
      this.renderErrors({
        general: {
          'general': 'An unexpected error occurred. Please try again later.'
        }
      })
    }
  }
}

